import styled from "styled-components";
import BREAKPOINTS from "../../Theme/Breakpoints";
import COLORS from "../../Theme/Colors";

export const HeaderWrapper = styled.div`
  width: 100%;
  position: fixed;
  display: flex;
  padding: 1rem 6rem;
  justify-content: space-between;
  box-sizing: border-box;
  top: 0;
  z-index: 1000;
  background-color: white;
  box-shadow: 0 10px 15px -5px hsla(0, 0%, 0%, 0.05);

  ${BREAKPOINTS.TABLET} {
    padding: 1.5rem 3rem;
  }

  ${BREAKPOINTS.MOBILE} {
    padding: 1.2rem 2rem;
  }
`;

export const Logo = styled.img`
  width: 40px;
  border: 3px solid ${COLORS.blue};
  border-radius: 50%;
  padding: 0.1rem;
  cursor: pointer;

  &:hover {
    border: 3px solid ${COLORS.darkblue};
  }
`;

export const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;

  ${BREAKPOINTS.TABLET} {
    gap: 2rem;
  }

  ${BREAKPOINTS.MOBILE} {
    gap: 0;
    top: 4.8rem;
    right: 0;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: calc(100vh - 4.8rem);
    background-color: white;
    padding: 3rem 0 6rem;
    transform: ${(props) =>
      props.open ? "translateX(0)" : "translateX(100%)"};
    transition: transform 0.4s ease;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
  font-size: 1.1rem;
  font-weight: 500;
  font-family: "Poppins", sans-serif;

  li {
    list-style-type: none;
    cursor: pointer;

    a {
      color: inherit;
      text-decoration: none;
    }

    &:hover {
      color: ${COLORS.blue};
    }
  }

  ${BREAKPOINTS.MOBILE} {
    flex-direction: column;
    gap: 0.7rem;
    padding: 4rem 0;
    font-size: 1.3rem;
  }
`;

export const Sticker = styled.div`
  display: none;
  justify-content: center;

  img {
    width: 170px;
  }

  ${BREAKPOINTS.MOBILE} {
    display: flex;
  }
`;

export const HamburgerMenu = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  justify-content: center;

  span {
    height: 2px;
    width: 25px;
    background: black;
    transition: transform 0.4s ease;
  }

  span:nth-of-type(1) {
    margin: ${(props) => (props.open ? "-1px" : "3px")};
    transform: ${(props) => (props.open ? "rotate(45deg)" : "rotate(0)")};
  }

  span:nth-of-type(2) {
    margin: ${(props) => (props.open ? "-1px 0" : "3px 0")};
    transform: ${(props) => (props.open ? "rotate(-45deg)" : "rotate(0)")};
  }

  ${BREAKPOINTS.MOBILE} {
    display: flex;
  }
`;
